const actionsListColumn = [
  { title: "id", dataIndex: "id", key: "id" },
  {
    title: "Label",
    dataIndex: "label",
    key: "label"
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description"
  },
  {
    title: "Question",
    dataIndex: "question",
    key: "question"
  },
  {
    title: "Condition",
    dataIndex: "condition",
    key: "condition",
    render: (text, record, index) => {
      const { condition } = record;

      return condition ? "Oui" : "Non";
    }
  },
  {
    title: "Format",
    dataIndex: "format",
    key: "format"
  },
  {
    title: "Affichage",
    dataIndex: "display",
    key: "display",
    render: (text, record, index) => {
      const { display } = record;

      return display ? "Oui" : "Non";
    }
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type"
  },
  {
    title: "Priorité",
    dataIndex: "priority",
    key: "priority"
  }
];

export default actionsListColumn;



// WEBPACK FOOTER //
// src/containers/admin/actions/ActionsList.utils.js